import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const ExactIntegrationForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    // Set the api object
    const apiObject = 'integration/exact_online';

    // Configure the job fields
    const fields: FieldType[] = [
        {
            type: 'header',
            header: "integrations.general.secrets_header",
            description: "integrations.general.exact_secrets_description"
        },
        {
            type: 'description',
            description: 'integrations.general.exact_add_integration_description',
            showOnEdit: false,
        },
        {
            type: 'text',
            name: 'client_id',
            label: 'integrations.general.client_id_label',
            placeholder: 'integrations.general.client_id_placeholder',
        },
        {
            type: 'secret',
            name: 'client_secret',
            label: 'integrations.general.client_secret_label',
            placeholder: 'integrations.general.client_secret_placeholder',
        },
        {
            type: 'secret',
            name: 'webhook_secret',
            label: 'integrations.general.webhook_secret_label',
            placeholder: 'integrations.general.webhook_secret_placeholder',
        },
        {
            type: 'header',
            header: "integrations.general.functions_header"
        },
        {
            name: 'import_relations',
            label: 'integrations.general.import_relations_label',
            type: 'switch',
        },
        {
            name: 'import_projects',
            label: 'integrations.general.import_projects_label',
            type: 'switch',
        },
        {
            name: 'export_hours',
            label: 'integrations.general.export_project_hours_label',
            type: 'switch',
        },
        {
            type: 'header',
            showOnEdit: true,
        },
        {
            name: 'is_active',
            label: 'integrations.general.is_active_label',
            type: 'checkbox',
            showOnEdit: true,
            tooltipText: 'integrations.general.is_active_tooltipText',
        },
    ];
    
    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            primaryButtonLabel='integrations.general.connect_button_label'
        />
    );
};

export default ExactIntegrationForm;